import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import LicenseDetailsSection from './components/LicenseDetailsSection';
import ExchangeAboutSection from './components/ExchangeAboutSection';

export default function LicensePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <LicenseDetailsSection />
        <ExchangeAboutSection />
      </main>
      <Footer />
    </div>
  );
}
